import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
export type UserBasicInfoFragment = { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null };

export const UserBasicInfoFragmentDoc = gql`
    fragment UserBasicInfo on User {
  id
  uuid
  email
  username
  photoUrl
  firstName
  lastName
}
    `;